<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              email
            </v-icon>
            <span class="title"><b>{{ this.kodesurat }}</b></span>
            <v-spacer></v-spacer>
            <v-btn
              :to="{ name: 'SuratAdmin' }"
              color="error"
              icon
              x-small>
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <alertsp :alertdata="alertgetdata"></alertsp>
              <div class="text-center" v-if="loading.getdata">
                <v-progress-circular
                  :width="3"
                  color="red"
                  indeterminate>
                </v-progress-circular>
              </div>
              <v-row justify="center" v-if="detaildata">
                <v-col cols="12" md="8" class="px-md-10 border-solid-thin text-justify">
                  <v-row justify="center" align="center">
                    <v-col cols="12" md="2" class="text-center">
                      <img class="mr-3" :src="require('../../assets/' + prefix + '/logo.png')" height="100"/>
                    </v-col>
                    <v-col cols="12" md="10" class="text-center">
                      <div class="title text-uppercase">KEMENTRIAN PENDIDIKAN, KEBUDAYAAN, <br/> RISET, DAN TEKNOLOGI</div>
                      <div class="title text-uppercase">POLITEKNIK NEGERI BALI</div>
                      <p>{{ staticdata.alamat }} | No.Telp: {{ staticdata.phone }}</p>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <div class="text-center text-underline title">SURAT KETERANGAN</div>
                      <div class="text-center">Nomor: {{ detaildata.no_skm ? detaildata.no_skm : '_______/_______/_______/_______' }}</div>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Yang bertanda tangan dibawah ini, {{ detaildata.user_as_spm }} {{ staticdata.desa }} menerangkan bahwa:</p>
                      <table class="ml-5 tbl-align-top">
                        <tr>
                          <td class="min-first-colm">Nama</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_nama }}</b></td>
                        </tr>
                        <tr>
                          <td class="min-first-colm">NIM</td>
                          <td>:</td>
                          <td><b>{{ detaildata.user_skm }}</b></td>
                        </tr>
                        <tr>
                          <td>Tempat / Tanggal Lahir</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_tempatlahir }} / {{ detaildata.p_tgllahir }}</b></td>
                        </tr>
                        <tr>
                          <td>Jenis Kelamin</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_kelamin | kelaminParse }}</b></td>
                        </tr>
                        <tr>
                          <td>Jurusan</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_jurusan }}</b></td>
                        </tr>
                        <tr>
                          <td>Program Studi</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_prodi }}</b></td>
                        </tr>
                        <tr>
                          <td>Jenjang</td>
                          <td>:</td>
                          <td><b>{{ detaildata.p_jenjang }}</b></td>
                        </tr>
                        <tr>
                          <td>Keterangan</td>
                          <td>:</td>
                          <td>Dengan ini menerangkan bahwa <b>{{ updatesurat.desc_skm }}</b></td>
                        </tr>
                      </table>
                    </v-col>
                  </v-row>
                  <v-row justify="center" align="center">
                    <v-col cols="12">
                      <p>Surat keterangan ini dipergunakan untuk <b>{{ updatesurat.peruntukan_skm }}</b>.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <p>Demikian surat keterangan ini kami buat dengan sebenarnya untuk dapat dipergunakan sebagaimana mestinya.</p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="12" md="6" class="text-right">
                      <div>Jimbaran, {{ new Date() | dateToIndo }}</div>
                      <div>{{ detaildata.user_as_spm ? detaildata.user_as_spm : '-' }}</div>
                      <img
                        v-if="detaildata.status_skm === 'siap'"
                        class="mr-3"
                        :src="detaildata.urlttd"
                        height="100"/>
                      <div
                        style="height: 100px;"
                        v-if="detaildata.status_skm !== 'siap'"></div>
                      <div>{{ detaildata.username_spm ? detaildata.username_spm : '-' }}</div>
                      <div>NIP. {{ detaildata.user_spm ? detaildata.user_spm : '-' }}</div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5" v-if="detaildata.no_skm">
                    <v-col cols="12" md="12">
                      <div class="d-flex align-top">
                        <div class="d-inline mr-3">
                          <qrcode-vue :value="detaildata.urlqr" size="80" level="H" class="d-inline"/>
                        </div>
                        <v-divider vertical></v-divider>
                        <div class="d-inline ml-3 caption">
                          <div>Dicetak menggunakan e-Surat PNB</div>
                          <div>Scan QRCode untuk verifikasi keaslian surat</div>
                        </div>
                      </div>
                      <!-- <v-divider vertical></v-divider> -->
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4" class="pl-md-10 pt-md-0">
                  <div class="text-right">
                    <v-chip
                      v-if="!canchange"
                      color="red"
                      fab
                      text-color="white">
                      <v-icon left>bookmark</v-icon>
                      {{ updatesurat.status_skm }}
                    </v-chip>
                  </div>
                  <v-form
                    ref="formupdatesurat"
                    v-model="formadd.valid"
                    lazy-validation>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.nama_js"
                          label="Jenis Surat"
                          name="jenis_surat">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          :disabled="true"
                          :readonly="true"
                          :value="detaildata.p_nama"
                          label="Nama Pemohon"
                          name="nama">
                        </v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          :disabled="!canchange"
                          v-model="updatesurat.desc_skm"
                          auto-grow
                          label="Deskripsi Surat"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-textarea
                          :disabled="!canchange"
                          v-model="updatesurat.peruntukan_skm"
                          auto-grow
                          label="Keperluan Surat"
                          :rules="[rules.required]"
                          rows="1">
                        </v-textarea>
                      </v-col>
                      <v-col cols="12">
                        <v-select
                          :disabled="!canchange"
                          :items="liststatus"
                          name="statussurat"
                          v-model="updatesurat.status_skm"
                          label="Status Surat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" v-if="detaildata.status_surat === 'siap'">
                        <v-text-field
                          :disabled="!canchange"
                          v-model="updatesurat.no_skm"
                          label="Nomor Surat"
                          name="nosurat"
                          required>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <alertsp :alertdata="alertdata"></alertsp>
                        <div class="text-center" v-if="loading.update">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-btn
                          v-if="!loading.update && canchange"
                          large
                          block
                          :disabled="!formadd.valid"
                          color="success"
                          class="mr-4 mt-5"
                          @click="submitUpdate">
                          Simpan
                        </v-btn>
                        <v-btn
                          large
                          block
                          :disabled="loading.printsurat || (detaildata.status_skm !== 'siap' && detaildata.status_skm !== 'tolak')"
                          color="primary"
                          class="mr-4 mt-5"
                          :loading="loading.printsurat"
                          @click="printSurat">
                          Download
                        </v-btn>
                        <v-btn
                          v-if="!canchange"
                          outlined
                          large
                          block
                          color="primary"
                          class="mr-4 mt-5"
                          :to="{ name: 'SuratAdmin' }">
                          Kembali
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getDateTodayId } from '../../utils/dateFormatCustom.js';
import { mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';

export default {
  name: 'SuratDetailDosen',
  props: ['kodesurat'],
  data: () => ({
    alertgetdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      update: false,
      printsurat: false,
    },
    prefix: process.env.VUE_APP_PREFIX,
    api: process.env.VUE_APP_API,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    baseurl: process.env.VUE_APP_BASEURL,
    liststatus: ['permohonan', 'siap', 'tolak'],
    listttd: [],
    detaildata: null,
    updatesurat: {
      desc_skm: '',
      status_skm: '',
      kd_skm: '',
      no_skm: '',
      kode_js: '',
      peruntukan_skm: '',
    },
    formadd: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 6 || 'Min 6 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
    },
    canchange: true,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'usernik',
      'staticdata',
    ]),
  },
  mounted() {
    if (this.kodesurat) {
      this.getDetailSurat();
    }
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    dateToIndo(value) {
      return getDateTodayId(value);
    },
    kelaminParse(value) {
      return value === 'L' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    printSurat() {
      if (this.tokenscr && this.detaildata.kode_surat && this.detaildata.nik_surat) {
        this.loading.printsurat = true;
        this.axios
          .get(
            this.api + '/api/surat/printsurat/' + this.detaildata.kode_surat + '/' + this.detaildata.nik_surat,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
              responseType: 'blob',
            },
          )
          .then((res) => {
            // console.log(res);
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', this.detaildata.kode_surat + '.doc');
              document.body.appendChild(link);
              link.click();
            }
            this.loading.printsurat = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.printsurat = false;
          });
      }
    },
    getTandatangan() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/setting/',
            {
              params: {
                slug: 'tandatangan',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listttd = resdata.data;
                this.updatesurat.ttd_surat = this.updatesurat.ttd_surat ? this.updatesurat.ttd_surat : this.listttd[0];
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    checkCanChange() {
      this.canchange = true;
      const denystatus = ['siap', 'tolak'];
      if (denystatus.indexOf(this.updatesurat.status_skm) >= 0) {
        this.canchange = false;
      }
    },
    getDetailSurat() {
      if (this.tokenscr) {
        this.loading.getdata = true;
        this.axios
          .get(
            this.api + '/api/surat/' + this.kodesurat,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                if (resdata.data.length > 0) {
                  this.detaildata = resdata.data[0];
                  this.detaildata.urlttd = this.api + '/images/spm/' + resdata.data[0].file_spm;
                  this.detaildata.urlqr = this.baseurl + '/verifikasi/' + resdata.data[0].kd_skm;
                  this.updatesurat.kd_skm = resdata.data[0].kd_skm;
                  this.updatesurat.desc_skm = resdata.data[0].desc_skm;
                  this.updatesurat.status_skm = resdata.data[0].status_skm;
                  this.updatesurat.no_skm = resdata.data[0].no_skm;
                  this.updatesurat.kode_js = resdata.data[0].kode_js;
                  this.updatesurat.peruntukan_skm = resdata.data[0].peruntukan_skm;
                  this.checkCanChange();
                  // this.getTandatangan();
                } else {
                  this.alertgetdata.show = true;
                  this.alertgetdata.type = 'error';
                  this.alertgetdata.text = 'Data tidak ditemukan!';
                }
              } else {
                this.alertgetdata.show = true;
                this.alertgetdata.type = 'error';
                this.alertgetdata.text = resdata.message;
              }
            } else {
              this.alertgetdata.show = true;
              this.alertgetdata.type = 'error';
              this.alertgetdata.text = 'Internal services error!';
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertgetdata.show = true;
            this.alertgetdata.type = 'error';
            this.alertgetdata.text = 'Internal services error!';
            this.loading.getdata = false;
          });
      }
    },
    submitUpdate() {
      this.alertdata.show = false;
      if (this.$refs.formupdatesurat.validate()) {
        if (this.tokenscr) {
          console.log(this.updatesurat);
          this.loading.update = true;
          this.axios
            .put(
              this.api + '/api/surat/',
              qs.stringify(
                this.updatesurat,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Permohonan surat "' + this.updatesurat.kd_skm + '" berhasil diperbaharui!';
                  this.getDetailSurat();
                  this.$root.$emit('app-getnotifiaction');
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.update = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
    QrcodeVue,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
